module.exports = __webpack_public_path__ + "img/t1-8.3b7bf415.png";